import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FormInputError from "./FormInputError"

interface DateFieldProps {
    className?: string;
    label?: string;
    required?: boolean;
    initialValue?: string;
    placeholder?: string;
    disabled?: boolean;
    onValueChange?: (value: string) => void;
    children?: React.ReactNode;
    errorMessage?: string;
    [key: string]: any;
}

const propTypes = {
    label: PropTypes.string,
    initialValue: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onValueChange: PropTypes.func,
    errorMessage: PropTypes.string
}

const defaultProps = {
    label: '',
    initialValue: '',
    placeholder: '',
    disabled: false,
    onValueChange: () => {},
    errorMessage: null
}

const DateField = ({
    className,
    label,
    required,
    initialValue,
    placeholder,
    disabled,
    onValueChange, // Use onValueChange to receive updated value
    children,
    errorMessage,
    ...props
}: DateFieldProps) => {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue); // Update the state when initialValue changes
    }, [initialValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
        onValueChange?.(event.target.value) // Call onValueChange with updated value
    }

    const classes = classNames(className, children ? 'input-container' : undefined)
    const inputClasses = classNames('w-100 mt-2 align-items-center date-field-input', errorMessage?  'mb-1' : 'mb-2')

    return (
        <>
            <div className={classes}>
                <div className="w-100">
                    <div className="d-flex font-xs font-bold">{label}{required && <span className="text-danger ms-1">*</span>}</div>
                    <input
                        className={inputClasses}
                        style={{height: '45px'}}
                        onChange={handleChange}
                        disabled={disabled}
                        value={value} // Use value from state
                        placeholder={placeholder}
                        aria-label="Date"
                        type="date"
                        {...props}
                    />
                </div>
                <div className="input-trailing">{children}</div>

                {
                    errorMessage &&
                    <FormInputError>{errorMessage}</FormInputError>
                }
            </div>
        </>
    )
}

DateField.propTypes = propTypes
DateField.defaultProps = defaultProps

export default DateField
